module.exports = __webpack_public_path__ + "static/img/2-1.d7cbe02.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/case/2-1.png
// module id = ovWS
// module chunks = 0